exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".terms-container{display:flex;align-items:center;border-radius:5px}.terms-container label{margin-left:5px}", ""]);

// exports
